export default __webpack_public_path__ + "static/media/Service.18d483d2.png";